import { createAsyncThunk } from '@reduxjs/toolkit';

export const onChangeCurrentCategory = createAsyncThunk(
  'onChangeCurrentCategory',
  async (
    data: { newCategoryId: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    if (data.newCategoryId !== null) {
      return { newCategoryId: data.newCategoryId };
    } else {
      return;
    }
  }
);

export default onChangeCurrentCategory;
